import { render, staticRenderFns } from "./FShipping.vue?vue&type=template&id=29d8de38&scoped=true"
import script from "./FShipping.vue?vue&type=script&lang=js"
export * from "./FShipping.vue?vue&type=script&lang=js"
import style0 from "./FShipping.vue?vue&type=style&index=0&id=29d8de38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d8de38",
  null
  
)

export default component.exports